import React from 'react';
import {
    Card,
    Col,
    Container,
    Row,
    Button,
    FormLabel,
    Form
} from 'react-bootstrap';
import SelectorPermission from "../../components/rolesPermissionModule/selector-permission";
import axios from "../../server/interceptors";
import {
    apiGetPermissions,
    apiCreatePermissions,
    DEFAULT_LANGUAGE,
    apiModifyPermissions,
    apiModifyApiKeys, apiCreateApiKeys
} from "../../config";
import SessionManager from "../../utils/authHandling/session-manager";
import {logoutUser} from "../../utils/authHandling/logout-user";
import {FormattedMessage} from "react-intl";
import SelectorApiKeys from "../../components/selectorApiKeys/selector-api-keys";
/**
 * The component (window) to handle api keys.
 */
class ApiKeyPage extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state = {
            id: null,
            loading: false,
            isEdit: false,
            addNew: false,
            resetBox: false,
            redirect: false,
            redoSearch: false,
            checkboxChecked: true,
            checkboxNewKey: false,
            key: '',
            desc: '',
            version: ''
        };

        this.handleNew = this.handleNew.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeNewKey = this.handleChangeNewKey.bind(this);
        this.handleVersionChange = this.handleVersionChange.bind(this);
    }

    handleVersionChange(e){
        this.setState({version: e.target.value, redoSearch: false});
    }
    handleChange(e) {
        this.setState({ checkboxChecked: e.target.checked });
    }

    handleChangeNewKey(e){
        this.setState({ checkboxNewKey: e.target.checked });
    }

    handleSelection(e) {
        this.setState({
            id: e.value,
            key: e.key,
            desc: e.platform,
            version: e.version,
            checkboxChecked: e.active === "1",
            isEdit: true,
            resetBox: false,
            redoSearch: false,
            checkboxNewKey: false,
        });
    }


    saveChanges(){
        // Create
        if(this.state.id === null)
        {
            this.setState({loading: true}, ()=>{
                // Call the API to insert
                let params = {
                    Version: this.state.version,
                    Active: this.state.checkboxChecked ? "1": "0",
                    PlatformDescription: this.state.desc,
                };

                axios.post(apiCreateApiKeys, params,{
                    headers: {
                        'Content-Type': 'application/json',                        
                    }}).then((response)=>{

                    if(response.status === 201 ||  response.status === 200)
                    {
                        this.setState({
                            redoSearch: true,
                            id: null,
                            key: '',
                            desc: '',
                            version: '',
                            checkboxChecked: true,
                            resetBox: true,
                            checkboxNewKey: false,
                        });
                        alert("Successfully created./La transacción fue procesada exitosamente.");
                    }
                    else
                    {
                        alert("Validate the fields. If the error continues, contact the administrator./Valide los campos. Si el error persiste, contacte al administrador.");
                    }
                    this.setState({loading: false});
                }).catch(error => {
                    if(error.response.status === 400)
                    {
                        if(typeof error.response.data !== 'undefined' && typeof error.response.data.Messages !== 'undefined' && error.response.data.Messages.length > 0)
                        {
                            let message = "";
                            for(let i=0;i<  error.response.data.Messages.length; i++)
                            {
                                message += error.response.data.Messages[i];
                            }
                            alert(message);
                        }
                    }
                    else {
                        alert(`Error: ${error}`);
                    }
                    this.setState({loading: false});
                });
            });
        }
        else
        {
            this.setState({loading: true}, ()=>{
                // Call the API to insert
                let params = {
                    Id: this.state.id,
                    Version: this.state.version,
                    Active: this.state.checkboxChecked ? "1": "0",
                    PlatformDescription: this.state.desc,
                };

                axios.post(`${apiModifyApiKeys}/${this.state.checkboxNewKey}`, params,{
                    headers: {
                        'Content-Type': 'application/json',                        
                    }}).then((response)=>{
                    if(response.status === 201 ||  response.status === 200)
                    {
                        this.setState({
                            redoSearch: true,
                            id: null,
                            key: '',
                            desc: '',
                            version: '',
                            checkboxChecked: true,
                            resetBox: true,
                        });
                        alert("Successful transaction./La transacción fue procesada exitosamente.");
                    }
                    else
                    {
                        alert("Validate the fields. If the error continues, contact the administrator./Valide los campos. Si el error persiste, contacte al administrador.");
                    }
                    this.setState({loading: false});
                }).catch(error => {
                    if(error.response.status === 400)
                    {
                        if(typeof error.response.data !== 'undefined' && typeof error.response.data.Messages !== 'undefined' && error.response.data.Messages.length > 0)
                        {
                            let message = "";
                            for(let i=0;i<  error.response.data.Messages.length; i++)
                            {
                                message += error.response.data.Messages[i];
                            }
                            alert(message);
                        }
                    }
                    else {
                        alert(`Error: ${error}`);
                    }
                    this.setState({loading: false});
                });
            });

        }

    }

    handleNew(){
        this.setState({
            addNew: true,
            id: null,
            key: '',
            desc: '',
            version: '',
            resetBox: true,
            checkboxChecked: true,
            checkboxNewKey: false,
            isEdit: false,
        });
    }

    handleDescriptionChange(e){
        this.setState({desc: e.target.value, redoSearch: false});
    }

    /**
     * Renders the main page
     * @returns {XML}
     */
    render() {

        return (
                <div className="container-padding animated delay-05s fadeIn">
                    <Container className="container-wrapper">
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header>
                                        <h2><FormattedMessage id="api-title"/></h2>
                                        <small><FormattedMessage id="api-subtitle"/></small>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>

                                            <Col xs={12} md={6}>
                                                <FormLabel>
                                                    <FormattedMessage id="api-select-to-edit"/>
                                                </FormLabel>
                                                <SelectorApiKeys resetBox={this.state.resetBox} redoSearch={this.state.redoSearch} disabled={this.state.addNew} updateParent={this.handleSelection}/>
                                            </Col>

                                            <Col>
                                                <FormLabel/>
                                                <br/>
                                                <button className="btn-transparent font-weight-bold text-color-dark-blue" onClick={this.handleNew}>
                                                    <FormattedMessage id="api-add-new"/>
                                                </button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={6}>
                                                <FormLabel>
                                                    <FormattedMessage id="api-key"/>
                                                </FormLabel>
                                                <input className="form-control" maxLength="45" value={this.state.key} type="text" name="key" disabled="disabled"
                                                       id="key"/>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xs={12} md={6}>
                                                <FormLabel>
                                                    * <FormattedMessage id="api-platform"/>
                                                </FormLabel>
                                                <input  className="form-control" value={this.state.desc} name="platform_description" disabled={!this.state.isEdit && !this.state.addNew ? "disabled" : ""}
                                                        id="key" onChange={this.handleDescriptionChange}/>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xs={12} md={6}>
                                                <FormLabel>
                                                    * <FormattedMessage id="api-version"/>
                                                </FormLabel>
                                                <input  className="form-control" value={this.state.version} name="version" disabled={!this.state.isEdit && !this.state.addNew ? "disabled" : ""}
                                                        id="key" onChange={this.handleVersionChange}/>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xs={12} md={6}>
                                                <Form.Check type="checkbox" checked={this.state.checkboxChecked} onChange={this.handleChange} label=<FormattedMessage id="api-active"/>/>
                                            </Col>
                                        </Row>

                                        {this.state.isEdit ?
                                            <Row>
                                                <Col xs={12} md={6}>
                                                    <Form.Check type="checkbox" checked={this.state.checkboxNewKey} onChange={this.handleChangeNewKey} label=<FormattedMessage id="api-generate-a-new-key"/>/>
                                                </Col>
                                            </Row> : null
                                        }

                                        <Row>
                                            <Col className="text-right">
                                                <Button color="success" disabled={this.state.desc === "" || this.state.version === "" ? "disabled" : ""} onClick={this.saveChanges}>
                                                    <FormattedMessage id="api-submit"/>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <hr/>
                    </Container>
            </div>
        )
    };
}

export default ApiKeyPage;